export default {
  title: "Dados para Estágio",
  update_form_answer: {
    update_form: "Formulário de atualização de cadastro",
    pendent: "pendente",
    click_here: "Clique aqui",
    to_answer: "para responder"
  }
}